import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/index/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/ranking/index.vue')
  },
  {
    path: '/search',
    name: 'serach',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/search/index.vue')
  },
  {
    path: '/bookDetail',
    name: 'detail',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/bookdetail/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/about/index.vue')
  },
  {
    path: '/vip',
    name: 'vip',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/vip/index.vue')
  },
  
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/privacy/index.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/service/index.vue')
  },
  {
    path: '/reader',
    name: 'reader',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/bookReader/index.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/agreement/index.vue')
  },
  {
    path: '/customer-center',
    name: 'customer-center',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/customer-center/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }else{
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export default router
